"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ostiglia": {
    "7205c054": [{
      "hkey": "2bcf346a",
      "slug": "ostiglia",
      "name": "Ostiglia",
      "primary": true,
      "skipSearch": false
    }],
    "agnella": [{
      "hkey": "2bcf346a",
      "slug": "ostiglia",
      "name": "Ostiglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "625740b5": [{
      "hkey": "856b3e02",
      "slug": "comuna-santuario",
      "name": "Comuna Santuario",
      "primary": true,
      "skipSearch": false
    }],
    "comuna-santuari": [{
      "hkey": "856b3e02",
      "slug": "comuna-santuario",
      "name": "Comuna Santuario",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f9042e49": [{
      "hkey": "2bcf346a",
      "slug": "ostiglia",
      "name": "Ostiglia",
      "primary": true,
      "skipSearch": false
    }],
    "core": [{
      "hkey": "2bcf346a",
      "slug": "ostiglia",
      "name": "Ostiglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e667c95f": [{
      "hkey": "17fcba13",
      "slug": "correggioli",
      "name": "Correggioli",
      "primary": true,
      "skipSearch": false
    }],
    "correggiol": [{
      "hkey": "17fcba13",
      "slug": "correggioli",
      "name": "Correggioli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "23d88d45": [{
      "hkey": "2bcf346a",
      "slug": "ostiglia",
      "name": "Ostiglia",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-molino": [{
      "hkey": "2bcf346a",
      "slug": "ostiglia",
      "name": "Ostiglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;